
    import React from 'react';
    import ReactDOM from 'react-dom';
    import EditorAppWrapper from 'yoshi-flow-editor-runtime/build/esm/EditorAppWrapper.js';

    import Widget from '/home/builduser/agent00/work/ad4ac254fb89a706/spotify-ooi/src/components/Spotify/Widget/index.tsx';
    import createController from '/home/builduser/agent00/work/ad4ac254fb89a706/spotify-ooi/src/components/Spotify/controller.ts';
    import {
      
    } from 'yoshi-flow-editor-runtime';
    
  import * as viewerApp from '/home/builduser/agent00/work/ad4ac254fb89a706/spotify-ooi/src/viewer.app.ts';
    var importedApp = viewerApp;



    var componentName = 'Spotify';
    var projectName = 'spotify-ooi';
    var sentryConfig = {
      DSN: 'https://01fb0c955b864231aa35321b27af56a8@sentry.wixpress.com/440',
      id: '01fb0c955b864231aa35321b27af56a8',
      projectName: 'spotify',
      teamName: 'music',
    };

    var stylesParams = null;

    var experimentsConfig = {"scope":"spotify"};

    var translationsConfig = null;

    var defaultTranslations = null;

    var biConfig = null;

    var appDefinitionId = "099ac204-be88-4ed1-89af-cf14358c83f1";
    var componentId = "53d0a5fa-3da5-418b-84d6-e58bd55fecad";

    var biLogger = null;

    
      import { hot } from 'component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      experimentsConfig: experimentsConfig,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        
      }
    });

    ReactDOM.render(EditorComponent, document.getElementById('root'));
